import {
	JOIN_EVENT_LOBBIES_ROOM,
	ON_EVENT_LOBBIES,
	LEAVE_EVENT_LOBBIES_ROOM,
} from '@sportspredict/shared';
import { useSocketRoom } from './use-socket-room.hook';

/**
 * Subscribes to the event-lobbies socket room (`ON_EVENT_LOBBIES`) and forwards every
 * payload to the caller-provided handler. Handles JOIN/LEAVE + reconnect via useSocketRoom.
 * Payloads carry `{ event }` (event updates, e.g. scheduled upcoming -> active) or `{ lobby }`;
 * the handler decides what to do with them.
 */
export function useEventLobbiesRoom({
	socket,
	enabled = true,
	handler,
}: {
	socket: any;
	enabled?: boolean;
	handler: (data: any) => void;
}) {
	useSocketRoom({
		socket,
		enabled: Boolean(socket) && enabled,
		eventName: ON_EVENT_LOBBIES,
		handler,
		join: () => socket?.emit(JOIN_EVENT_LOBBIES_ROOM),
		leave: () => socket?.emit(LEAVE_EVENT_LOBBIES_ROOM),
	});
}
